<script setup lang="ts">
import { computed } from 'vue'

const { color, count } = defineProps<{
  color: 'red' | 'green' | 'black'
  count: number
}>()

const mainStackCount = computed(() => (count < 8 ? count : count < 16 ? 7 : 10))
const showExtraChip = computed(() => count >= 8)
const showSecondStack = computed(() => count > 15)
</script>

<template>
  <div class="chips" :class="`chips--${color}`">
    <div class="chips__stack chips__stack--main">
      <div class="chips__item" v-for="i in mainStackCount" :key="i" />
    </div>
    <div class="chips__stack chips__stack--second" v-if="showSecondStack">
      <div class="chips__item" v-for="i in 5" :key="i" />
    </div>
    <div class="chips__extra-chip" v-if="showExtraChip">
      <div class="chips__item" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chips.chips--red .chips__item {
  background-image: url('@/assets/chip.png');
}
.chips.chips--green .chips__item {
  background-image: url('@/assets/chip--green.png');
}
.chips.chips--black .chips__item {
  background-image: url('@/assets/chip--black.png');
}

.chips {
  --table-chip-width-adjusted: calc(var(--table-chip-width) * 1.3);
  --table-chip-height-adjusted: calc(var(--table-chip-height) * 1.3);

  position: relative;
  width: var(--table-chip-width-adjusted);
  height: var(--table-chip-height-adjusted);
}

.chips__stack {
  width: var(--table-chip-width-adjusted);
  height: var(--table-chip-height-adjusted);

  &--main {
    position: relative;
    z-index: 9;
  }
  &--second {
    position: absolute;
    bottom: calc(var(--table-chip-height-adjusted) * 0.2);
    left: calc(var(--table-chip-width-adjusted) * -0.5);
  }
}
.chips__extra-chip {
  z-index: 10;
  position: absolute;
  bottom: 0;
  left: calc(var(--table-chip-width-adjusted) * 0.4);
  bottom: 0;

  .chips__item {
    transform: rotate(57deg);
  }
}

.chips__item {
  transition: all 0.15s ease-in-out;

  background-image: url('@/assets/chip.png');
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.25));
  background-size: cover;
  width: var(--table-chip-width-adjusted);
  height: var(--table-chip-height-adjusted);
  position: absolute;
  bottom: 0;
}

@for $i from 1 to 11 {
  .chips__stack > .chips__item:nth-child(#{$i}) {
    bottom: calc(var(--table-chip-width-adjusted) * ($i * 0.075));
  }
}
</style>
